<template>
  <div class="tracking-status">
    <div class="d-flex line">
      <div class="progress tracking-dots" :class="isActive(1).active">
        <div
          role="progressbar"
          class="progress-bar"
          :style="{ width: `${isActive(1).completed}%` }"
        ></div>
      </div>
      <div
        class="progress tracking-dots"
        v-if="cs === 2"
        :class="isActive(2).active"
      >
        <div
          role="progressbar"
          class="progress-bar"
          :style="{ width: `${isActive(2).completed}%` }"
        ></div>
      </div>
      <div class="progress tracking-dots" :class="isActive(3).active">
        <div
          role="progressbar"
          class="progress-bar"
          :style="{ width: `${isActive(3).completed}%` }"
        ></div>
      </div>
    </div>
    <div class="d-flex justify-content-between">
      <div class="status text-left">
        <h4>
          {{
            cc &&
            cc.departure &&
            cc.departure.location &&
            cc.departure.location.toLowerCase()
          }}
        </h4>
        <h3>{{ formatDate(cc.departure) }}</h3>
      </div>
      <div class="status text-center" v-if="cs === 2">
        <h4>
          {{
            cc &&
            cc.current &&
            cc.current.location &&
            cc.current.location.toLowerCase()
          }}
        </h4>
        <h3>{{ formatDate(cc.current) }}</h3>
      </div>
      <div class="status text-right">
        <h4>
          {{
            cc &&
            cc.arrival &&
            cc.arrival.location &&
            cc.arrival.location.toLowerCase()
          }}
        </h4>
        <h3>
          {{ formatDate(cc.arrival) }}
          <span
            v-b-tooltip.hover
            :title="$t('invoices.tracking.container.delayed')"
            v-if="isLate"
            ><b-icon-exclamation-triangle-fill class="text-warning"
          /></span>
        </h3>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['cc', 'cs'],
  computed: {
    isLate() {
      let currentDate = new Date()
      let arrivalDate =
        this.cc && this.cc.arrival && this.cc.arrival.time !== null
          ? new Date(this.cc.arrival.time)
          : ''
      return (
        currentDate > arrivalDate &&
        this.cc.arrival.location !== this.cc.current.location
      )
    }
  },
  methods: {
    formatDate(rawDateFormat) {
      return typeof rawDateFormat !== 'undefined' && rawDateFormat.time !== null
        ? this.$moment(new Date(rawDateFormat.time)).format('MMM DD, YYYY')
        : 'NA'
    },
    isActive(i) {
      if (this.cs === i) {
        return {
          active: 'active',
          completed: 0
        }
      } else if (this.cs < i) {
        return {
          active: 'disabled',
          completed: 0
        }
      } else {
        return {
          active: 'completed',
          completed: 100
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../../assets/scss/variables';
.tracking-status {
  margin: 0;
  position: relative;
  .status {
    color: $gray-600;
    h4 {
      font-size: 0.9rem;
      margin: 0.25rem 0;
      text-transform: capitalize;
    }
    h3 {
      font-size: 0.8rem;
    }
  }
  .line {
    transform: scale(0.94);
    .progress {
      height: 0.2rem;
      flex: 1;
      margin: 2rem 0 1rem;
      &:before {
        margin-left: -10px;
        top: 20px;
      }
      &:after {
        margin-left: -5px;
        top: 25px;
      }
      &:last-child {
        flex: 0;
      }
    }
  }
}
</style>
